import { Box, Button, Flex, Grid, Heading, HStack, Image, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { SHOWCASES } from 'const';
import { AppleIcon } from 'icons/AppleIcon';
import { GooglePlayIcon } from 'icons/GooglePlay';

export const MobileShowcase: React.FC = () => {
  return (
    <Box py={20} bg="gradient.to.br" bgGradient="linear(to-br, gray.50, white)">
      <Box maxW="container.xl" mx="auto">
        <Grid
          templateColumns={{ base: '1fr', lg: '1fr 1fr' }}
          gap={{ base: '50px', md: '100px' }}
          alignItems="center"
        >
          <VStack align="start">
            <VStack align="start">
              <Heading size="2xl" lineHeight="shorter">
                Biznesinizi Uzaqdan İdarə Edin
              </Heading>
              <Text fontSize="lg" color="gray.600" lineHeight="tall">
                CaspiPos mobil tətbiqi biznesinizin hər yerdən izlənməsini və idarə edilməsini
                asanlaşdırır. İstifadəçi dostu interfeysi ilə satışları izləyin və əməliyyatları
                idarə edin.
              </Text>
            </VStack>

            <VStack align="stretch" w="100%">
              {SHOWCASES.map((feature, index) => (
                <HStack
                  key={index}
                  align="start"
                  p={4}
                  bg="white"
                  borderRadius="lg"
                  border="1px solid"
                  borderColor="gray.200"
                  transition="all 0.2s"
                  _hover={{
                    borderColor: feature.color,
                    shadow: 'md'
                  }}
                >
                  <Box
                    fontSize="2xl"
                    bg={`${feature.color.split('.')[0]}.50`}
                    p={3}
                    borderRadius="lg"
                    flexShrink={0}
                  >
                    <Text>{feature.icon}</Text>
                  </Box>
                  <VStack align="start" flex={1}>
                    <Heading size="sm" color="gray.800">
                      {feature.title}
                    </Heading>
                    <Text fontSize="sm" color="gray.600">
                      {feature.description}
                    </Text>
                  </VStack>
                </HStack>
              ))}
            </VStack>

            <HStack pt={4}>
              <Button
                size="lg"
                bg="black"
                color="white"
                borderRadius="xl"
                px={6}
                _hover={{
                  bg: 'gray.800'
                }}
              >
                <AppleIcon /> App Store
              </Button>
              <Button
                size="lg"
                bg="black"
                color="white"
                borderRadius="xl"
                px={6}
                _hover={{
                  bg: 'gray.800'
                }}
              >
                <GooglePlayIcon /> Google Play
              </Button>
            </HStack>
          </VStack>

          <Flex gap={8} flexDirection={{ base: 'column', md: 'row' }}>
            <Box
              bg="gray.900"
              borderRadius="3xl"
              overflow="hidden"
              border="8px solid"
              borderColor="gray.800"
              boxShadow="2xl"
              h="100%"
              display="flex"
              flexDirection="column"
            >
              <Image
                src="assets/mobile-dashboard-full.png"
                alt="Mobile Dashboard"
                objectFit="cover"
                w="100%"
                h="100%"
                borderRadius="lg"
              />
            </Box>
            <Box
              bg="gray.900"
              borderRadius="3xl"
              overflow="hidden"
              border="8px solid"
              borderColor="gray.800"
              boxShadow="2xl"
              h="100%"
              display="flex"
              flexDirection="column"
            >
              <Image
                src="assets/online-user-screen.jpeg"
                alt="Online Users"
                objectFit="cover"
                w="100%"
                h="100%"
                borderRadius="lg"
              />
            </Box>
          </Flex>
        </Grid>
      </Box>
    </Box>
  );
};
